import React, { useContext } from "react";

import { type GetPrizesElementResponseType } from "@jti/rest-api-types";

export type PrizeLocatorContextType = {
  labels: {
    pointsLabel: string;
    searchHeader: string;
    searchBar: string;
    searchButton: string;
    storesCount: string;
    rewardsText: string;
    loadMoreLabel: string;
    backToListLabel: string;
    getDirectionLabel: string;
    redeemButtonLabel: string;
    categoryFilterTitle: string;
    noOffersText: string;
    venuePopUpOffersCount: string;
    currentPositionButtonText: string;
    newOfferDays?: number;
    newLabel: string;
    oneDayLabel?: string;
    daysLabel?: string;
    outOfStockLabel?: string;
    discoverButtonText?: string;
  };
  userPointsBalance: number;
  pagination: number;
  handleRedeemClick: (prize: GetPrizesElementResponseType) => void;
  tier: string;
  discoverUrlParent?: string;
};

export const PrizeLocatorContext = React.createContext<PrizeLocatorContextType | null>(null);

export const usePrizeLocatorContext = () => {
  const context = useContext(PrizeLocatorContext);

  if (!context) {
    throw new Error("usePrizeLocatorContext hook is used outside of PrizeLocatorContext");
  }

  return context;
};
